<template>
  <div class="step1" v-if="content.type==8&&content.show">
    <p>你的目标职业是<span class="protrude">{{content.title}}</span>。对一个好的<span class="protrude">{{content.title}}</span>来说，有一些能力项是特别重要的，能把优秀和水平一般区分开来。请选取最少10个你看重的能力。</p>
    <div class="element-box1">
      <p>目标行动相关：</p>
      <ul class="direction-box">
        <li :class="[selected[0][index]?'selected':'',index>3?'col2':'col4']" v-for="(item,index) in content.option1" @click="selectCurrent(item,index,0)">{{item.name}}
        </li>
      </ul>
    </div>
    <div class="element-box2">
      <p>帮助与服务相关：</p>
      <ul class="direction-box">
        <li class="col2" :class="selected[1][index]?'selected':''" v-for="(item,index) in content.option2" @click="selectCurrent(item,index,1)">{{item.name}}
        </li>
      </ul>
    </div>
    <div class="element-box1">
      <p>影响力相关：</p>
      <ul class="direction-box">
        <li :class="[selected[2][index]?'selected':'',index>2?'col2':'col3']" v-for="(item,index) in content.option3" @click="selectCurrent(item,index,2)">{{item.name}}
        </li>
      </ul>
    </div>
    <div class="element-box2">
      <p>管理相关：</p>
      <ul class="direction-box">
        <li class="col4" :class="selected[3][index]?'selected':''" v-for="(item,index) in content.option4" @click="selectCurrent(item,index,3)">{{item.name}}
        </li>
      </ul>
    </div>
    <div class="element-box1">
      <p>认知相关：</p>
      <ul class="direction-box">
        <li :class="[selected[4][index]?'selected':'',index>2?'col4':'col3']" v-for="(item,index) in content.option5" @click="selectCurrent(item,index,4)">{{item.name}}
        </li>
      </ul>
    </div>
    <div class="element-box2">
      <p>自我认知相关：</p>
      <ul class="direction-box">
        <li class="col4" :class="selected[5][index]?'selected':''" v-for="(item,index) in content.option6" @click="selectCurrent(item,index,5)">{{item.name}}
        </li>
      </ul>
    </div>
    <div class="errorMessage">{{content.errorMessage}}</div>
    <div class="modal-box" v-if="modalShow">
      <div class="modal-content">
        <div class="modal-body">
          <p class="modal-title">{{currentName}}</p>
          <p class="modal-text" v-html="currentDefinition"></p>
        </div>
        <p class="tips">确定要选择？</p>
        <div class="btn-group">
          <button class="default-btn primary-btn" @click="ToSave" v-preventReClick>确定</button>
          <button class="default-btn disabled-btn" @click="ToCancel">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    content:Object
  },
  data(){
    return{
      selected: [
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false]
        ],
      chooseValue:[{'sub':3,'list':[]},{'sub':4,'list':[]},{'sub':5,'list':[]},{'sub':6,'list':[]},{'sub':7,'list':[]},{'sub':8,'list':[]}],
      totalCount:0,
      modalShow:false,
      currentNum:-1,
      currentName:'',
      currentDefinition:''
    }
  },
  methods:{
    selectCurrent(item,index,sub){
      this.currentNum = sub
      this.currentName = item.name
      this.currentDefinition = item.definition
      // 判断是否已选中过
      let num =-1
      this.chooseValue.map((para,zindex)=>{
        if(para.sub==sub+3){
          para.list.map((single,xindex)=>{
            if(single.name==item.name){
              num = xindex
            }
          })
        }
      })
      // 如果是已选中过,取消选中,如果没选中,弹出介绍框
      if(num>=0){
        this.totalCount--
        this.chooseValue[sub].list.splice(num,1)
        this.$set(this.selected[sub], index, false)
      }else{
        this.modalShow = true
        item.index = index
        this.chooseValue[sub].list.push(item)
        this.chooseValue[sub].list.sort((a,b)=>{return a.index-b.index})
      }
    },
    ToCancel(){
      this.modalShow = false
      if(this.currentNum>=0){
        let n =this.chooseValue[this.currentNum].list.length
        if(n>0){
          this.chooseValue[this.currentNum].list.map((item,index)=>{
            if(item.name==this.currentName){
              this.chooseValue[this.currentNum].list.splice(index,1)
            }
          })
        }
        if(this.totalCount<10){
          this.content.errorMessage="至少选择10项"
        }else{
          this.content.errorMessage=""
          this.$emit("listenToChildEvent",this.chooseValue,this.content.num)
        }
      }
    },
    ToSave(){
      this.totalCount++
      this.modalShow = false
      if(this.currentNum>=0){
        let n =this.chooseValue[this.currentNum].list.length
        if(n>0){
          this.chooseValue[this.currentNum].list.map((item,index)=>{
            if(item.name==this.currentName){
              this.$set(this.selected[this.currentNum], item.index, true)
            }
          })
        }
        if(this.totalCount<10){
          this.content.errorMessage="至少选择10项"
        }else{
          this.content.errorMessage=""
          this.$emit("listenToChildEvent",this.chooseValue,this.content.num)
        }
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .element-box1
    background-color:#C2E8F1
    margin:0.1rem
    padding:0.1rem
  .element-box2
    background-color:#CDCDCD
    margin:0.2rem 0.1rem
    padding:0.1rem
  .element-box3
    background-color:#C1E7F0
    margin:0.1rem
    padding:0.1rem
  .direction-box
    overflow:hidden
    li
      float:left
      background-color:#FFFFFF
      margin:0.1rem
      padding:1px
      border-radius:6px
      display: flex;
      display:-webkit-flex;
      justify-content: center;/*水平居中*/
      align-items: center;/*垂直居中*/
      -webkit-align-items:center;
      height:0.8rem
      line-height:0.3rem
    .selected
      background-color:#DC6E5A
      color:#ffffff
    .col2
      width:46%
    .col3
      width:29%
    .col4
      width: 21%
      text-align: center
  .protrude
    color:#DC6E5A
    font-weight:bold
  .modal-box
    .modal-content
      background-color:#F5F5F5
      .modal-body
        background-color:#FFFFFF
        border:1px solid #BBBBBB
        margin:0.3rem
        padding:0.1rem
        .modal-title
          color:#434343
        .modal-text
          text-align:left
          color:#777777
      .tips
        color:#101010
      .btn-group
        overflow:hidden;
        width:90%
        margin:auto
        .default-btn
          display:inline-block
          width:44%
        .primary-btn
          float:left
          background-color:#008DCF
        .disabled-btn
          float:right
          background-color:#B5B5B5
</style>